import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Provider } from "react-redux";
import { store } from "./store/store";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { ThemeProvider, CssBaseline } from "@mui/material";
import theme from "./theme";
import PaletteSwitcher from "./theme/PaletteSwitcher";

// Web fonts — keep in sync with src/theme/tokens.js → fonts
import "@fontsource-variable/inter";
import "@fontsource-variable/fraunces";

import "./index.scss";
const qc = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 60_000, refetchOnWindowFocus: false },
  },
});

const app = (
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <HelmetProvider>
          <BrowserRouter>
            <QueryClientProvider client={qc}>
              <App />
              <PaletteSwitcher />
            </QueryClientProvider>
          </BrowserRouter>
        </HelmetProvider>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);

const container = document.getElementById("root");

if (container.hasChildNodes()) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}

reportWebVitals();
